import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { getDefaultRouteForRole } from '@/lib/navigation'

const LandingPage = lazy(() => import('@/pages/marketing/LandingPage'))

/**
 * `/` is the public marketing page for anonymous visitors. A signed-in
 * user landing here (a stale bookmark, clicking the logo) is sent straight
 * to their own default screen instead of seeing the pitch again.
 */
export function RootRoute() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    )
  }

  if (user) {
    return <Navigate to={getDefaultRouteForRole(user.role)} replace />
  }

  return <LandingPage />
}
